import { CreditCategory } from "../models/accounting/credit/credit-category";
import { CreditReason } from "../models/accounting/credit/credit-reason";
import { CachedStoreObject } from "../models/utilities/cached-store-object";
import { BaseModuleState } from "./_BaseModuleState";

export class AccountingModuleState extends BaseModuleState {

    // Credits
    public creditCategories : CachedStoreObject<CreditCategory[]> = {} as CachedStoreObject<CreditCategory[]>;
    public creditReasons    : CachedStoreObject<CreditReason[]> = {} as CachedStoreObject<CreditReason[]>;

}
